import { ChevronLeft, ChevronRight, cn } from "@app/ui";
import { Link } from "react-router-dom";
import { useI18n } from "../../lib/useI18n.js";
import { useSettingsStore } from "../../stores/index.js";

/**
 * The "X-Days" calendar tab: a Link to /calendar/days labelled with the live day
 * count, flanked by ◂ ▸ arrows that adjust the persisted count. Extracted from
 * CalendarHeader to keep that file lean.
 */
export function DayCountControl({ active, compact = false }: { active: boolean; compact?: boolean }) {
  const { t } = useI18n();
  const dayCount = useSettingsStore((s) => s.calendarDayCount);
  const setDayCount = useSettingsStore((s) => s.setCalendarDayCount);
  return (
    <span className="inline-flex shrink-0 items-center whitespace-nowrap">
      <button
        type="button"
        aria-label={t("calendar.fewerDays")}
        className={cn("grid h-7 place-items-center rounded hover:bg-accent", compact ? "w-5 min-[341px]:w-6" : "w-6")}
        onClick={() => void setDayCount(dayCount - 1)}
      >
        <ChevronLeft className="h-3 w-3" />
      </button>
      <Link
        to="/calendar/days"
        className={cn(
          "rounded py-1 tabular-nums leading-5 whitespace-nowrap",
          compact ? "px-1.5 min-[341px]:px-2" : "px-2",
          active ? "bg-primary text-primary-foreground" : "hover:bg-accent",
        )}
      >
        {t("calendar.dayCount", { count: dayCount })}
      </Link>
      <button
        type="button"
        aria-label={t("calendar.moreDays")}
        className={cn("grid h-7 place-items-center rounded hover:bg-accent", compact ? "w-5 min-[341px]:w-6" : "w-6")}
        onClick={() => void setDayCount(dayCount + 1)}
      >
        <ChevronRight className="h-3 w-3" />
      </button>
    </span>
  );
}
